import React, { FunctionComponent } from 'react'
import { Switch } from 'react-router-dom'

import Route from '../../../shared/routes/Route'
import { DetalhesLoteSolicitadoFactory } from '../factories/DetalhesLoteSolicitado'
import Filtros from '../factories/Filtros'
import { ListLotesSolicitadosFactory } from '../factories/ListLotesSolicitados'
import { FiltrosProvider } from '../hooks/filtros'

const LotesSolicitadosRoutes: FunctionComponent = () => {
  return (
    <Switch>
      <FiltrosProvider>
        <Route
          path="/lotes-solicitados/filtros"
          isPrivate
          exact
          component={Filtros}
        />

        <Route
          path="/lotes-solicitados"
          isPrivate
          exact
          component={ListLotesSolicitadosFactory}
        />

        <Route
          path="/lotes-solicitados/detalhes"
          isPrivate
          exact
          component={DetalhesLoteSolicitadoFactory}
        />
      </FiltrosProvider>
    </Switch>
  )
}

export default LotesSolicitadosRoutes
